var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-inputs"},[_c('FormLabelTooltip',{attrs:{"name":_vm.name,"label":_vm.label}}),_c('Multiselect',{class:{ error: _vm.error },attrs:{"options":_vm.options,"multiple":true,"taggable":true,"max":_vm.max,"close-on-select":false,"clear-on-select":false,"placeholder":_vm.placeholder,"preselect-first":false},on:{"change":(event) => {
				_vm.$emit('input', event.target.value);
			},"select":(event) => {
				_vm.$emit('select', event);
			},"remove":(event) => {
				_vm.$emit('select', event);
			}},scopedSlots:_vm._u([{key:"selection",fn:function({ values, search, isOpen }){return undefined}}]),model:{value:(_vm.selectedOptions),callback:function ($$v) {_vm.selectedOptions=$$v},expression:"selectedOptions"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }